"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionKeyForPyr = exports.questionKeyForQre = void 0;
const questionKeyForQre = (taxYearStartDate) => `qre-${taxYearStartDate}`;
exports.questionKeyForQre = questionKeyForQre;
const questionKeyForPyr = (taxYearStartDate) => `pyr-${taxYearStartDate}`;
exports.questionKeyForPyr = questionKeyForPyr;
